import { Box, Card, Divider, Typography } from '@mui/material';
import { FC } from 'react';
import { useTripCardStyles } from './useTripCardStyles';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SplitIcon from '@mui/icons-material/ViewAgendaOutlined';
import CleaningIcon from '@mui/icons-material/LocalCarWashOutlined';
import CheckInIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import LocalGasStation from '@mui/icons-material/LocalGasStation';
import Group from '@mui/icons-material/Group';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

import {
  AccessTime,
  CheckCircleOutline,
  MoreHorizOutlined,
  PeopleOutlined,
  Title,
  PersonAdd,
} from '@mui/icons-material';
import { InfoCard, InfoCardContent } from '../InfoCard/InfoCard';
import { IconType } from '../../enums/IconType';
import { DutyActivity, Trip } from '../../models/workday';
import React from 'react';

type Props = {
  icon: IconType;
  primary1: string;
  primary2: string;
  secondary1: string;
  secondary2: string;
  comment?: string;
  tripIsEu?: boolean;
  dutyActivity:DutyActivity;
};

export const TripCardContent: FC<Props> = ({
  icon,
  primary1,
  primary2,
  secondary1,
  secondary2,
  comment,
  tripIsEu,
  dutyActivity,
}) => {
  const classes = useTripCardStyles();
  return (
    <>
       <Box sx={classes.heading} px={2} py={1}>
        <Box textAlign="center" mr={3}>
       
          {icon === IconType.Bus && (
            <Box sx={classes.col}>
              <DirectionsBusIcon fontSize="large" />
            </Box>
          )}
          {icon === IconType.Check && <CheckCircleOutline fontSize="large" />}
          {icon === IconType.CheckIn && <CheckInIcon fontSize="large" />}
          {icon === IconType.Cleaning && <CleaningIcon fontSize="large" />}
          {icon === IconType.Coffee && <FreeBreakfastIcon fontSize="large" />}
          {icon === IconType.Food && <RestaurantIcon fontSize="large" />}
          {icon === IconType.Other && <MoreHorizOutlined fontSize="large" />}
          {icon === IconType.Ride && <PeopleOutlined fontSize="large" />}
          {icon === IconType.Split && <SplitIcon fontSize="large" />}
          {icon === IconType.Reserve && <PersonAdd fontSize="large" />}
          {icon === IconType.Unknown && <Title fontSize="large" />}
          {icon === IconType.Wait && <AccessTime fontSize="large" />}
          {icon === IconType.Walk && <DirectionsWalkIcon fontSize="large" />}
          {icon === IconType.HourglassEmpty && <HourglassEmptyIcon fontSize="large" />}
          {icon === IconType.LocalGasStation && (
            <LocalGasStation fontSize="large" />
          )}
          {icon === IconType.Group && <Group fontSize="large" />}
          {tripIsEu && <img style={classes.euLogo} src="/assets/eu-flag.jpg" alt="EU" />}
        </Box>
        <Box sx={classes.col}>
          {dutyActivity?.Trip === undefined || dutyActivity?.Trip === null || dutyActivity?.Trip.length === 0 &&
          <React.Fragment>
          <Typography variant="h5">{primary1}</Typography>
          <Typography variant="h5">{primary2}</Typography>
          <Typography variant="subtitle2">{secondary1}</Typography>
          <Typography variant="subtitle2">{secondary2}</Typography>
          </React.Fragment>
          }

          {dutyActivity?.Trip.map(function(trip:Trip, i) {
		          return(<React.Fragment>
                <Typography variant="h5">{trip.TrpType == 1 && "Åk med ingående fordon omlopp " + trip.TrpBlock || trip.TrpType == 2 && "Åk med utgående fordon omlopp " + trip.TrpBlock || trip.TrpType == 3 && "Åk med tomkörning fordon imlopp " + trip.TrpBlock || trip.TrpRouteTransdevSpecial}</Typography>
                <Typography variant="subtitle1">{trip.TravelDuties}</Typography>
                <Typography variant="subtitle2">{trip.TripPoint[0].TrpptDepartureTime} - {trip.TripPoint[0].StpDescription}</Typography>
                <Typography variant="subtitle2">{trip.TripPoint[dutyActivity.Trip[0].TripPoint.length-1].TrpptDepartureTime} - {trip.TripPoint[dutyActivity.Trip[0].TripPoint.length-1].StpDescription}</Typography>
                {i !== dutyActivity?.Trip.length-1 &&
                 <Divider style={{width:'100%', paddingTop:'1px', marginTop:'15px', marginBottom:'15px'}} sx={{ bgcolor: "secondary.light" }} />
                }
                </React.Fragment>
                )})}
          
        </Box>
      </Box>
    </>
  );
};

export const TripCard: FC = ({ children }) => {
  const classes = useTripCardStyles();
  return <Card sx={classes.root}>{children}</Card>;
};
